export default __webpack_public_path__ + "static/media/shield-double.092dedf8.svg";